import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import { IRedirection } from '.';

export type TAdminGetRedirections = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminCreateRedirection = {
  oldUrl: string;
  newUrl: string;
};

export type TAdminUpdateRedirection = {
  _id: string;
  oldUrl: string;
  newUrl: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetRedirectionsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetRedirections) => {
  let path = `${AdminApiPaths.redirections}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IRedirection>>
  >(path);

  return response.data;
};

export const adminCreateRedirection = createAsyncThunk(
  '/admin/redirection/create',
  async (data: TAdminCreateRedirection) => {
    const path = `${AdminApiPaths.redirections}`;

    const response = await apiDataProvider.post<TApiResponse<IRedirection>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminUpdateRedirection = createAsyncThunk(
  '/admin/redirection/update',
  async (data: TAdminUpdateRedirection) => {
    const path = `${AdminApiPaths.redirections}/${data._id}`;

    const response = await apiDataProvider.put<TApiResponse<IRedirection>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminDeleteRedirection = createAsyncThunk(
  '/admin/redirection/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.redirections}/${id}`;

    const response = await apiDataProvider.delete<TApiResponse<IRedirection>>(
      path
    );

    return response.data;
  }
);

export const adminGetRedirections = createAsyncThunk(
  '/admin/redirection/list',
  adminGetRedirectionsModule
);
